import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthProvider";
import { motion } from "framer-motion";

const SelectionPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAdmin = user?.UserRole === "Admin";

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-bl from-[#0f172a] via-[#1e1a78] to-[#0f172a] text-white p-4">
      <div className="flex flex-col items-center justify-center w-full max-w-md mx-auto text-center">
        <motion.h1
          className="text-3xl md:text-7xl lg:text-9xl font-bold mb-2 md:mb-4"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          குறளாட்டம்
        </motion.h1>

        <motion.h1
          className="text-lg md:text-4xl lg:text-6xl font-bold mb-4 md:mb-6 bg-gradient-to-r from-green-500 via-yellow-400 to-orange-600 bg-clip-text text-transparent"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          கொண்டாட்டம்
        </motion.h1>

        <div className="flex flex-col space-y-6 w-full max-w-md">
          <button
            onClick={() => navigate("/aattam")}
            className="px-8 py-4 text-xl font-semibold rounded-xl bg-gradient-to-r from-green-500 to-blue-500 hover:from-green-600 hover:to-blue-600 text-white shadow-lg transform hover:scale-105 transition-transform duration-200 mx-auto w-full max-w-xs"
          >
            Play Game
          </button>

          {isAdmin && (
            <button
              onClick={() => navigate("/admin")}
              className="px-8 py-4 text-xl font-semibold rounded-xl bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white shadow-lg transform hover:scale-105 transition-transform duration-200 mx-auto w-full max-w-xs"
            >
              Admin Dashboard
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SelectionPage;
